import { PropsWithChildren } from "react";

type PhoneMockupProps = PropsWithChildren<{
  title: string;
}>;

export function PhoneMockup({ title, children }: PhoneMockupProps) {
  return (
    <div className="rounded-[2rem] border border-borderSoft bg-white p-2 shadow-soft transition duration-300 hover:-translate-y-1">
      <div className="rounded-[1.6rem] border border-brand-100 bg-panel p-3">
        <p className="pb-3 text-center text-sm font-extrabold uppercase tracking-wide text-brand-700">
          {title}
        </p>
        <div className="rounded-[1.1rem] bg-white p-3">{children}</div>
      </div>
    </div>
  );
}
